import { useEffect, useState } from "react"
import { useIncidencia } from "../../../hooks/GestionIncidencias/useIncidencia"
import { primeraLetraMayusculaOracion } from "../../../utils/utils";
import { BotonProcesosPGI } from "../../components/buttons/BotonProcesosPGI";
import { Tooltip } from "../../components/utils/Tooltip";
import { ContenedorTabla } from "../../components/utils/ContenedorTabla";
import { Lista } from "../../components/Lista";


export const GestionIncidencias = () => {
    const [ startDate, setStartDate ] = useState( new Date());
    const [ endDate, setEndDate ] = useState( new Date());
    const [ procesoElegido, setProcesoElegido ] = useState(0);
    const [ numeroProceso, setNumeroProceso ] = useState(0);
    const [ filtro, setFiltro ] = useState('')
    const procesos = [
        {nombre: 'Validar', numeroEstado: 1, color: ' bg-gray-900 ', descripcion: '' }, //Validar
        {nombre: 'Derivar', numeroEstado: 2, color: ' bg-gray-800 ', descripcion: ''  }, //Validar
        {nombre: 'Resolver', numeroEstado: 3, color: ' bg-gray-700 ', descripcion: '' }, //Visualizar detalle
        {nombre: 'Verificar ', numeroEstado: 4, color: ' bg-gray-600 ', descripcion: '' }, //Finalizar
    ]
    const { listarIncidencias, incidencias } = useIncidencia();

    useEffect(() => {
        listarIncidencias();
    },[startDate, endDate])





    const Fila = ({  index, style, data }) => {
        const inc = data.incidencias[index];
        return(
            <section
                style={style}
                className='contents row '
                key={`row-${index}`}
            >
                <section className='text-center px-2'>{index + 1}</section>
                <section className='text-center px-2'>
                    <span
                        className={`bg-blue-600 relative rounded px-2 `}
                    >{inc.codIncidencia ? inc.codIncidencia : inc.codIncidenciaEmpresa}</span>
                </section>
                <section className="text-center px-2 whitespace-nowrap text-ellipsis overflow-hidden">{inc.fechaHoraCreacion}</section>
                <section className="px-2">
                    <section className=' whitespace-nowrap text-ellipsis overflow-hidden' key={'div_' + inc.tituloIncidencia }>
                        {primeraLetraMayusculaOracion(inc.tituloIncidencia != '' ? inc.tituloIncidencia : 'Incidencia registrada desde TGPS')}
                        <Tooltip id={inc.tituloIncidencia}>
                            {primeraLetraMayusculaOracion(inc.tituloIncidencia)}
                        </Tooltip>
                    </section>
                </section>
                <section className="px-2  whitespace-nowrap">
                    {primeraLetraMayusculaOracion(inc.nomEmpresa)}
                </section>
                <section className='text-center px-2'>
                    <BotonProcesosPGI
                        // otherAction={obtenerDetalleIncidencia}
                        procesos={procesos}
                        // openModal={openModalProcesosIncidencia}
                        numeroProceso={inc.nroProceso}
                        setNumeroProceso={setNumeroProceso}
                        procesoElegido={procesoElegido}
                        setProcesoElegido={setProcesoElegido}
                        informacion={inc}
                    />
                </section>
            </section>
        );
    };

    return(
        <>
        <input className="bg-zinc-800" onChange={(e) => setFiltro(e.target.value)}/>




            <ContenedorTabla>
                <table
                    // id={idTablaIncidencias}
                    className=" tableResponsive "
                >
                    <thead>
                        <tr key={'head-1'} className=' uppercase w-[99.5%] grid grid-cols-[3%_5%_15%_30%_17%_30%]'>
                            <th className=" text-center">N</th>
                            <th className=' text-center'>Código</th>
                            <th className=" text-center">
                                <span>F. registro</span>
                            </th>
                            <th className="text-left">Incidencia</th>
                            <th className="text-left">Empresa solic.</th>
                            <th className="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            incidencias.length > 0 ?
                                <Lista
                                    altura={750}
                                    cantidadTotal={incidencias.length}
                                    largoItem={33}
                                    anchoColumnas="3% 5% 15% 30% 17% 30%"
                                >
                                    {({ index, style })  => (
                                        <Fila
                                            index={ index }
                                            style={ style }
                                            data={{ incidencias }}
                                        />
                                    )}
                                </Lista>
                            :
                            <tr><td colSpan={6} className='text-center'>No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>
        </>
    )
} 